import { useEffect, useState } from "react";
import { LoadingContainer, Logo, LoadingStatus } from "./Styles";

const loadingStatesByLanguage: Record<string, string[]> = {
  en: ["Processing your request", "Searching knowledge base", "Preparing your response"],
  hi: ["आपके अनुरोध को प्रोसेस कर रहे हैं", "ज्ञान आधार खोज रहे हैं", "आपका उत्तर तैयार कर रहे हैं"],
  te: ["మీ అభ్యర్థనను ప్రాసెస్ చేస్తున్నాము", "జ్ఞాన ఆధారం వెతుకుతున్నాము", "మీ ప్రతిస్పందనను సిద్ధం చేస్తున్నాము"],
  ta: ["உங்கள் கோரிக்கையை செயலாக்குகிறோம்", "ஜ்ஞாந்த ஆதாரத்தை வெட்டுகிறோம்", "உங்கள் பதிலை தயாரிக்கிறோம்"],
  bn: ["আপনার অনুরোধ প্রক্রিয়া করা হচ্ছে", "জ্ঞান আধার খোজ রহয়য়ে", "আপনার উত্তর তয়ার করা হয়"],
  kn: ["ನಿಮ್ಮ ವಿನಂತಿಯನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತಿದೆ", "ಜ್ಞಾನ ಭಂಡಾರವನ್ನು ಹುಡುಕಲಾಗುತ್ತಿದೆ", "ನಿಮ್ಮ ಪ್ರತಿಕ್ರಿಯೆಯನ್ನು ಸಿದ್ಧಪಡಿಸಲಾಗುತ್ತಿದೆ"],
  ml: ["നിങ്ങളുടെ അഭ്യർത്ഥന പ്രോസസ് ചെയ്യുന്നു", "ജ్ഞാന ആധാരം തിരയുന്നു", "നിങ്ങളുടെ മറുപടി തയ്യാറാക്കുന്നു"],
  mr: ["तुमचा विनंतीचा मजकूर प्रक्रिया करत आहोत", "ज्ञान आधार खोज रहे हैं", "तुमचे उत्तर तयार करत आहोत"],
  gu: ["તમારી વિનંતી પ્રક્રિયા કરી રહ્યા છીએ", "જ్ઞાન આધાર શોધી રહ્યા છીએ", "તમારો પ્રતિભાવ તૈયાર કરી રહ્યા છીએ"],
  ur: ["آپ کی درخواست پر عمل کیا جا رہا ہے", "جان پایہ ڈھونڈ رہا ہے", "آپ کا جواب تیار کیا جا رہا ہے"],
  pa: ["ਤੁਹਾਡੀ ਬੇਨਤੀ ਪ੍ਰੋਸੈਸ ਕੀਤੀ ਜਾ ਰਹੀ ਹੈ", "ਜਾਣ ਪਾਈ ਆਧਾਰ ਲੱਭਿਆ ਜਾ ਰਿਹਾ ਹੈ", "ਤੁਹਾਡਾ ਜਵਾਬ ਤਿਆਰ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ"],
  or: ["ଆପଣଙ୍କ ଅନୁରୋଧ ପ୍ରକ୍ରିୟା କରାଯାଉଛି", "ଜ୍ଞାନ ଭଣ୍ଡାର ଖୋଜା ହେଉଛି", "ଆପଣଙ୍କ ପ୍ରତିକ୍ରିୟା ପ୍ରସ୍ତୁତ କରାଯାଉଛି"],
  as: ["আপোনাৰ অনুৰোধ প্ৰক্ৰিয়াকৰণ কৰা হৈছে", "জ্ঞান ভাণ্ডাৰ সন্ধান কৰা হৈছে", "আপোনাৰ উত্তৰ প্ৰস্তুত কৰা হৈছে"],
};

type LoadingProps = {
  selectedLanguage?: string;
  skipIntentStep?: boolean;
};

export default function Loading({
  selectedLanguage = "en",
  skipIntentStep = false,
}: LoadingProps) {
  const languageStates =
    loadingStatesByLanguage[selectedLanguage] || loadingStatesByLanguage.en;
  const loadingStates = skipIntentStep
    ? [languageStates[0], languageStates[2]]
    : languageStates;
  const [statusIndex, setStatusIndex] = useState(0);

  useEffect(() => {
    setStatusIndex(0);
  }, [selectedLanguage, skipIntentStep]);

  useEffect(() => {
    if (statusIndex >= loadingStates.length - 1) return; // stop at last
  
    const interval = setInterval(() => {
      setStatusIndex((prevIndex) => prevIndex + 1);
    }, 1400);
  
    return () => clearInterval(interval);
  }, [statusIndex, loadingStates.length]);

  return (
    <LoadingContainer className="LoadingContainer">
      <Logo className="Logo" src="a_logo.png" alt="Assistant logo" />
      <LoadingStatus key={statusIndex} className="LoadingStatus">
        {loadingStates[statusIndex]}
      </LoadingStatus>
    </LoadingContainer>
  );
}